import React, { useMemo } from 'react';
import { TWatchesCommandsTypes } from 'types';
import { watchesCommandsTypes } from 'appConstants';
import { defaultSelectedCommand } from '../../watchesState/watchesContext';
import { Rule } from 'antd/lib/form';
import FormSelect from 'components/Select/FormSelect';
import style from './CommandsMultipleSelect.module.scss';

interface ICommandsMultipleSelect {
	setCommands: (value: TWatchesCommandsTypes[]) => void;
}

const CommandsMultipleSelect: React.FC<ICommandsMultipleSelect> = ({ setCommands }) => {
	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: 'Select at least one commands' }], []);

	const handleChange = (value: TWatchesCommandsTypes[]) => {
		if (value.length) {
			setCommands(value);
		} else {
			setCommands(defaultSelectedCommand);
		}
	};

	return (
		<FormSelect
			containerClassName={style.select}
			testId="CommandsMultipleSelect"
			name="commands"
			label="Commands"
			options={watchesCommandsTypes}
			onChange={handleChange}
			validationRules={validationRules}
			mode="multiple"
			showSearch={false}
		/>
	);
};

export default React.memo(CommandsMultipleSelect);
